<div class="mat-table-container">
  <table
    mat-table
    [dataSource]="dataSource"
    class="tabla-moderna mat-elevation-z0"
  >
    <!-- Código -->
    <ng-container matColumnDef="codigo">
      <th mat-header-cell *matHeaderCellDef>Código</th>
      <td mat-cell *matCellDef="let p">{{ p.orderCode }}</td>
    </ng-container>

    <!--Método de pago-->
    <ng-container matColumnDef="metodoPago">
      <th mat-header-cell *matHeaderCellDef>Método de pago</th>
      <td mat-cell *matCellDef="let p">
        {{ getMetodoPagoTexto(p.paymentMethod) }}
      </td>
    </ng-container>

    <!-- Cliente -->
    <ng-container matColumnDef="cliente">
      <th mat-header-cell *matHeaderCellDef>Cliente</th>
      <td mat-cell *matCellDef="let p">{{ p.customerName }}</td>
    </ng-container>

    <!-- Fecha -->
    <ng-container matColumnDef="fecha">
      <th mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let p">
        {{ p.createdAt | date : "dd/MM/yyyy HH:mm" }}
      </td>
    </ng-container>

    <!--Delivery-->
    <ng-container matColumnDef="delivery">
      <th mat-header-cell *matHeaderCellDef>Delivery</th>
      <td mat-cell *matCellDef="let p">
        {{ p.deliveryType === 1 ? "NO" : "SI" }}
      </td>
    </ng-container>

    <!-- Destino -->
    <ng-container matColumnDef="destino">
      <th mat-header-cell *matHeaderCellDef>Dirección</th>
      <td mat-cell *matCellDef="let p">
        {{ p.deliveryAddress || "Retiro en local" }}
      </td>
    </ng-container>

    <!--Estado-->
    <ng-container matColumnDef="estado">
      <th mat-header-cell *matHeaderCellDef>Estado</th>

      <td mat-cell *matCellDef="let p">
        <button mat-button [matMenuTriggerFor]="menuEstado" class="estado-btn">
          <span class="badge" [ngClass]="getEstadoClase(p.status)">
            {{ getEstadoTexto(p.status) }}
          </span>
        </button>

        <mat-menu #menuEstado="matMenu">
          <button
            mat-menu-item
            *ngFor="let estado of estados"
            (click)="cambiarEstado(p, estado)"
          >
            {{ getEstadoTexto(estado) }}
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <!-- Total -->
    <ng-container matColumnDef="total">
      <th mat-header-cell *matHeaderCellDef>Total</th>
      <td mat-cell *matCellDef="let p">${{ p.totalAmount }}</td>
    </ng-container>

    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let pedido">
        <!-- Botón de consulta de pedido-->
        <button
          mat-icon-button
          color="primary"
          (click)="consultarDetalles(pedido)"
          class="btn-action"
          matTooltip="Detalles del pedido"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="editarPedido(pedido)"
          class="btn-action"
          matTooltip="Modificar el pedido"
        >
          <mat-icon>edit</mat-icon>
        </button>
        <!-- Botón Eliminar -->
        <button
          mat-icon-button
          color="warn"
          (click)="eliminarPedido(pedido)"
          class="btn-action"
          matTooltip="Eliminar el pedido"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <!-- Botón Descarga -->
        <button
          mat-icon-button
          (click)="imprimirPedido(pedido)"
          class="btn-action"
          matTooltip="Imprimir el pedido"
        >
          <mat-icon>print</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Renderizado general -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="tabla-row"
    ></tr>
  </table>

  <!-- PAGINADOR -->
  <mat-paginator
    [pageSize]="5"
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
  ></mat-paginator>
</div>
